<div class="row">
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-body">
                <div class="align-box-row align-items-start">
                    <div class="font-weight-bold">
                        <small class="text-black-50 d-block mb-1 text-uppercase">New Accounts</small>
                        <span class="font-size-xxl mt-1">586,356</span>
                    </div>
                    <div class="ml-auto">
                        <div class="bg-love-kiss text-center text-white font-size-xl d-50 rounded-circle">
                            <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <fa-icon [icon]="['fas', 'arrow-up']" class="text-success"></fa-icon>
                    <span class="text-success px-1">15.4%</span>
                    <span class="text-black-50">increase this month</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-body">
                <div class="align-box-row align-items-start">
                    <div class="font-weight-bold">
                        <small class="text-black-50 d-block mb-1 text-uppercase">Sales</small>
                        <span class="font-size-xxl mt-1">23,274</span>
                    </div>
                    <div class="ml-auto">
                        <div class="bg-happy-fisher text-center text-white font-size-xl d-50 rounded-circle">
                            <fa-icon [icon]="['far', 'dot-circle']"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <fa-icon [icon]="['fas', 'arrow-up']" class="text-warning"></fa-icon>
                    <span class="text-warning px-1">5.9%</span>
                    <span class="text-black-50">same as before</span>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-body">
                <div class="align-box-row align-items-start">
                    <div class="font-weight-bold">
                        <small class="text-black-50 d-block mb-1 text-uppercase">Orders</small>
                        <span class="font-size-xxl mt-1">345</span>
                    </div>
                    <div class="ml-auto">
                        <div class="bg-plum-plate text-center text-white font-size-xl d-50 rounded-circle">
                            <fa-icon [icon]="['far', 'keyboard']"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <fa-icon [icon]="['fas', 'arrow-up']" class="text-danger"></fa-icon>
                    <span class="text-danger px-1">5.9%</span>
                    <span class="text-black-50">lower order numbers</span>
                </div>
            </div>
        </div>
    </div>
</div>
